import { createFileRoute } from '@tanstack/react-router'
import TeacherExamSchedule from '@/components/teacherPage/TeacherExamSchedule'
import { guardTeacherOnly } from '@/lib/auth/routeGuards'

export const Route = createFileRoute('/teacher/exam-schedule')({
  component: TeacherExamSchedulePage,
  beforeLoad: guardTeacherOnly,
})

function TeacherExamSchedulePage() {
  return <TeacherExamSchedule />
}
